<w-page mode="pseudo-page" [icon]="attachmentIcon" [title]="$safeNavigationMigration(attachment?.title)" (close)="dialog.close()" [headerSize]="'small'" [hideHeader]="false" [hideFooter]="true">

    <!-- /* The content in here appears header next to the close button */ -->
    <ng-container *w-page-header-actions>
        @if(showDownLoad){
            <w-button [iconLeft]="downloadIcon" [label]="'Download'" (onClick)="downloadAttachment()"></w-button>
        }
    </ng-container>

    <!-- /* The content in here appears above the body */ -->
    <!-- <ng-container *w-page-body-header>
    </ng-container> -->

    <!-- /* The content here appears in the body and scrollable */ -->
    <ng-container *w-page-body-content>
        <attachments [mode]="AttachmentsDisplayMode.Carousel" [tenantUrl]="tenantUrl" [gridGap]="0" [attachmentId]="attachmentId" [attachments]="$safeNavigationMigration(activity?.attachments) | call: safeAttachments" (itemClicked)="onAttachmentSelected($event)"></attachments>
    </ng-container>

    <!-- /* The content here appears below the body */ -->
    <!-- <ng-container *w-page-body-footer>
    </ng-container> -->

    <!-- /* The content here appears in the footer on the left */ -->
    <!-- <ng-container *w-page-footer-left-actions>
    </ng-container> -->

    <!-- /* The content here appears in the footer on the right */ -->
    <!-- <ng-container *w-page-footer-right-actions>
    </ng-container> -->

</w-page>